import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import Modal from "react-modal";
import DataCompareService from "../../services/DataCompareService";
import {Container, Row} from "react-bootstrap";
import TitleAndInputBox from "../common/dataView/TitleAndInputBox";
import axios from "axios";
import UserService from '../../services/UserService';
import ModalCloseButton from "../common/modal/ModalCloseButton";
import {toast} from "react-toastify";
import ToastAlertView from "../common/alert/ToastAlertView";

const modalStyle = {
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    content: {
        color: 'black',
        width: '400px',
        height: '380px',
        margin: 'auto'
    }
}

const EditShippingAddress = ({ data, isOpen, setIsOpen, onRefresh, orderId }) => {

    const { t, i18n } = useTranslation();
    const [requestBody, setRequestBody] = useState({
        locationPostalCode : "",
        locationAddress : "",
        locationAddressDetail : ""
    });
    const [isValidMap, setIsValidMap] = useState({
        locationPostalCode : true,
        locationAddress : true,
        locationAddressDetail : true
    });
    const [isValid, setIsValid] = useState(true);
    const [isEdited, setIsEdited] = useState(false);

    /* utils */
    const updateRequestBody = (key, value) => {
        setRequestBody(prevObj => {
            let newObj = {...prevObj};
            newObj[key] = value;
            return newObj;
        })
    };

    const updateIsValidMap = (key, value) => {
        setIsValidMap(prevObj => {
            let newObj = {...prevObj};
            newObj[key] = value;
            return newObj;
        })
    };

    /* handlers */
    const handlePostalCodeInput = (value) => {
        updateRequestBody("locationPostalCode", value);
    }

    const handleAddressInput = (value) => {
        updateRequestBody("locationAddress", value);
    };

    const handleAddressDetailInput = (value) => {
        updateRequestBody("locationAddressDetail", value);
    }

    /* validators */
    const validatePostalCode = () => {
        if (requestBody["locationPostalCode"] === "") {
            updateIsValidMap("locationPostalCode", false);
        } else {
            updateIsValidMap("locationPostalCode", true);
        }
    }

    const validateAddress = () => {
        if (requestBody["locationAddress"] === "") {
            updateIsValidMap("locationAddress", false);
        } else {
            updateIsValidMap("locationAddress", true);
        }
    }

    const validateAddressDetail = () => {
        if (requestBody["locationAddressDetail"] === "") {
            updateIsValidMap("locationAddressDetail", false);
        } else {
            updateIsValidMap("locationAddressDetail", true);
        }
    }

    /* put order address */
    const putAddress = async () => {
        try {
            let fetchUrl = `${process.env.REACT_APP_IMS_SERVER_URL}:${process.env.REACT_APP_IMS_SERVER_PORT}/api/v1/order/${orderId}/address`;
            const res = await UserService.updateToken(() => axios.put(
                fetchUrl,
                JSON.stringify(requestBody),
                {
                    headers : {
                        Authorization : `Bearer ${window.sessionStorage.getItem("ims_accessToken")}`,
                        "Content-Type" : "application/json"
                    }
                }
            ));
            toast.success(<ToastAlertView message={t("message.saved")} />);
            onRefresh();
            setIsOpen(false);
        } catch (e) {
            toast.error(<ToastAlertView message={t("message.failed")} />);
            console.log(e);
        }
    }

    /* effects */
    useEffect(() => {
        setRequestBody(DataCompareService.deepCopyObj(data));
    }, [data]);
    /* validate */
    useEffect(() => {
        validatePostalCode();
    }, [requestBody["locationPostalCode"]]);

    useEffect(() => {
        validateAddress();
    }, [requestBody["locationAddress"]]);

    useEffect(() => {
        validateAddressDetail();
    }, [requestBody["locationAddressDetail"]]);

    /* isValid */
    useEffect(() => {
        setIsValid(DataCompareService.checkIsAllTrue(isValidMap));
    }, [isValidMap]);

    /* isEdited */
    useEffect(() => {
        setIsEdited(!DataCompareService.isSameObj(data, requestBody));
    }, [requestBody]);

    return (
        <Modal
            style={modalStyle}
            isOpen={isOpen}
            onRequestClose={() => {
                setIsOpen(false);
            }}
        >
            <div
                style={{
                    width: '100%',
                    height: '100%'
                }}
            >
                <Container fluid>
                    <Row>
                        <ModalCloseButton
                            title={t("button.editShipAddress")}
                            setIsOpen={setIsOpen}
                        />
                    </Row>
                    <Row>
                        <TitleAndInputBox
                            title={t("menu.order.detail.content.shipInfo.postalCode")}
                            value={requestBody["locationPostalCode"]}
                            onChange={handlePostalCodeInput}
                            isForEdit={true}
                            type={"text"}
                            isValid={isValidMap["locationPostalCode"]}
                            isEnabled={true}
                        />
                    </Row>
                    <Row>
                        <TitleAndInputBox
                            title={t("menu.order.detail.content.shipInfo.address")}
                            value={requestBody["locationAddress"]}
                            onChange={handleAddressInput}
                            isForEdit={true}
                            type={"text"}
                            isValid={isValidMap["locationAddress"]}
                            isEnabled={true}
                        />
                    </Row>
                    <Row>
                        <TitleAndInputBox
                            title={t("menu.order.detail.content.shipInfo.detail")}
                            value={requestBody["locationAddressDetail"]}
                            onChange={handleAddressDetailInput}
                            isForEdit={true}
                            type={"text"}
                            isValid={isValidMap["locationAddressDetail"]}
                            isEnabled={true}
                        />
                    </Row>
                    <Row>
                        <div
                            style={{
                                width: '100%',
                                marginTop: '25px'
                            }}
                        >
                            {
                                isEdited && isValid ?
                                    <button
                                        id={"long-save-btn"}
                                        onClick={() => putAddress()}
                                    >
                                        {t("button.save")}
                                    </button>
                                    :
                                    <button
                                        id={"long-save-btn-disabled"}
                                    >
                                        {t("button.save")}
                                    </button>
                            }
                        </div>
                    </Row>
                </Container>
            </div>
        </Modal>
    );
};

export default EditShippingAddress;